import React from 'react';

import type { SharedValue } from 'react-native-reanimated';
import type { ListRef } from '@banhala/ui-kit';
import type { MarketHomeContentsKeys } from '../../../types/MarketHomeContents';

export const ScrollContext = React.createContext<{
  scrollY?: SharedValue<number>;
  categoriesScrollX?: SharedValue<number>;
  subCategoriesScrollX?: SharedValue<number>;
  listRef?: React.RefObject<ListRef<MarketHomeContentsKeys> | null>;
}>({});
